import {
  GET_BRANCHES,
  get_BRANCH_LIST,
  ADD_BRANCH,
  UPDATE_BRANCH,
  DELETE_BRANCH,
  UPDATE_BRANCH_STATUS,
  GET_BRANCH_DETAILS,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const branchesSlice = createCrudSlice({
  name: "branches",
  urls: {
    getList: GET_BRANCHES,
    getDropdownList: get_BRANCH_LIST,
    add: ADD_BRANCH,
    update: UPDATE_BRANCH,
    delete: DELETE_BRANCH,
    updateStatus: UPDATE_BRANCH_STATUS,
    getDetails: GET_BRANCH_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
    permissions: [],
  },
});

// Export actions
export const { setFilter, resetFilters } = branchesSlice.actions;

// Export thunks
export const {
  getList: getBranches,
  getDropdownList: getBranchesList,
  add: addBranch,
  update: updateBranch,
  delete: deleteBranch,
  updateStatus: updateBranchStatus,
  getDetails: getBranchDetails,
} = branchesSlice.thunks;

// Export reducer
export default branchesSlice.reducer;
